import { Autocomplete, TextField } from '@mui/material';
import type { SavedPresetRecord } from '../../model/types';

interface Props {
  presets: SavedPresetRecord[];
  value?: SavedPresetRecord;
  onChange: (preset: SavedPresetRecord) => void;
}

export function UpdatePreset({ presets, value, onChange }: Props) {
  return (
    <Autocomplete
      fullWidth
      disableClearable
      slotProps={{
        popper: { sx: { zIndex: 1301 } },
      }}
      options={presets}
      value={value}
      getOptionLabel={(preset) => preset.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Preset to update"
          InputProps={{
            ...params.InputProps,
            sx: {
              borderRadius: 2,
              height: 40,
            },
            inputProps: {
              ...params.inputProps,
              sx: {
                fontWeight: 400,
                fontSize: '0.875rem',
                lineHeight: '1rem',
                letterSpacing: 0,
              },
            },
            size: 'small',
          }}
        />
      )}
      isOptionEqualToValue={(preset, value) => {
        return preset.id === value.id;
      }}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
    />
  );
}
